import service from "@hybird/core/request";
import url from "@hybird/device/request";
import { BeginSealDeviceMethodInterceptor } from "@hybird/device/interceptor/beginSeal/core";
import { DeviceEvent } from "@hybird/core/device/protocol";
import { config } from "@hybird/device/config";
import { defaultError, WebError } from "@hybird/core/error";

export class OcrBeginSealInterceptor extends BeginSealDeviceMethodInterceptor {

  async equipmentLock(proceed, self, params = {}) {
    params.sendEquipmentLock = params.sendEquipmentLock && !params.directUse ? params.sendEquipmentLock : async () => {
      const documentRemoteId = new Date().getTime() + "" + Math.floor(Math.random() * 10) + 1;

      self.deviceProtocol.emit(DeviceEvent.EQUIPMENT_LOCK, { documentRemoteId });

      return {
        documentRemoteId
      }
    }

    if (!params.uploadApplyFileId && !params.ocrAllwholeCopy) {
      throw WebError.code(defaultError.ILLEGAL_ARGUMENT, { msg: "附件id不能为空" });
    }

    const result = await proceed(params)

    const documentRemoteId = result.documentRemoteId;
    const ocrUpload = async ({ fileId, isScannerUpload = false }) => {
      const ocrParams = {
        'documentId': self.deviceInfo.documentId,
        'fileUserIds': fileId,
        'sealId': self.deviceInfo.sealId,
        isScannerUpload,
        'fileInfo': {
          address: config.address,
          lon: config.gps.lon,
          lat: config.gps.lat
        },
        'uploadApplyFileId': !params.ocrAllwholeCopy ? params.uploadApplyFileId : undefined
      }

      return await service.post(
        params.ocrAllwholeCopy ? url.ocrAll : url.ocr,
        ocrParams,
        { timeout: 10 * 60 * 1000  }
      ).catch(async e => {
        // result.examineResult({ documentRemoteId, state: 2 });
        throw e;
      }).then(async ({ data }) => {
        if (self.deviceInfo.ocrPattern === 2) {
          self.context.data.uploadBefore = true;
        }

        result.data = data;
        result.matchStatus = data.matchStatus;
        result.isMatch = 2;
        result.isChance = 2;
        //1:可提交审核  2: 无审核, 3:自动提交审核 4:自动通过
        result.isManualAudit = 2;
        result.isSeal = 2;
        result.exec = () => {
        };

        //"1、匹配，可以盖印\n" +
        //"2、不匹配可盖印\n" +
        //"3、不匹配，还有次数\n" +
        //"4、不匹配，次数到上限\n" +
        //"5、无需OCR对比，可以盖印\n" +
        //"6. 不匹配，没有次数\n" +
        //"7. 不匹配，次数到上限，自动人工审核\n" +
        //"8. 不匹配，没有次数，自动人工审核\n" +
        //"9. 不匹配，自动人工审核通过\n" + 
        //"10. 不匹配，还有次数，可提交人工审核"
        switch (data.matchStatus) {
          case 1:
          case 5:
            result.isMatch = 1;
            result.isSeal = 1;
            result.exec = async () => {
              await result.examineResult({ documentRemoteId, state: 1 });
            };
            break;
          case 9:
            result.isManualAudit = 4;
            result.isMatch = 2;
            result.isSeal = 1;

            result.exec = async () => {
              await result.examineResult({ documentRemoteId, state: 1 });
            };
            result.ocrApproval = async () => {
            };
            break;
          case 2:
            result.isMatch = 2;
            result.isSeal = 1;
            result.exec = async () => {
              await result.examineResult({ documentRemoteId, state: 1 });
            };
            break;
          case 3:
            result.isChance = 1;
            break;
          case 4:
            break;
          case 6:
            //达到次数
            break;
          case 7:
          case 8:
            //自动人工审核
            result.isManualAudit = 3;
            result.ocrApproval = () => {
            };
            break;
          case 10:
            result.isManualAudit = 1;
            result.ocrApproval = () => {
              return service.post(url.ocrApproval, {
                'documentId': self.deviceInfo.documentId,
                'fileId': !params.ocrAllwholeCopy ? params.uploadApplyFileId : undefined,
                'isScannerUpload': +isScannerUpload,
                'ocrPattern': self.deviceInfo.ocrPattern,
                'sealId': self.deviceInfo.sealId,
                'uniqueId': data.uniqueId
              })
            }
            break;
        }

        return result;
      })
    };

    if (params.directUse) {
      const ocrReduce = await service.post(url.ocrReduce, {
        'documentId': self.deviceInfo.documentId,
        'fileId': params.uploadApplyFileId,
        'sealId': self.deviceInfo.sealId
      });

      if (self.deviceInfo.ocrPattern === 2) {
        self.context.data.uploadBefore = true;
      }

      result.examineResult({
        state: 1,
        directUse: true
      });
    } else {
      result.upload = result.upload ? result.upload.andThen(ocrUpload) : ocrUpload
    }

    return result;
  }

  isSupport(self) {
    return self.option.sealAuthentication === 1 && self.deviceInfo.isOpenOcr && self.deviceInfo.examineFinish !== 1;
  }
}
